export function sunHoursLabel(start: string | null, end: string | null): string | null {
  if (!start || !end) return null;
  const toMin = (s: string) => {
    const [h, m] = s.split(":").map(Number);
    return (h ?? 0) * 60 + (m ?? 0);
  };
  const diff = toMin(end) - toMin(start);
  if (!Number.isFinite(diff) || diff <= 0) return null;
  const hours = Math.round((diff / 60) * 10) / 10;
  return `${hours}h of sun`;
}

export function isSunRangeInvalid(start: string | null, end: string | null): boolean {
  if (!start || !end) return false;
  return sunHoursLabel(start, end) === null;
}
